<template>
    <div v-if="location_href.startsWith('http://127.0.0.1')">
        <b-checkbox v-model="debug" @change="(v) => $store.commit('changeDebugMode', v)" switch>Debug mode</b-checkbox>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    data() {
        return {
            location_href: window.location.href
        };
    },
    computed: mapState(["debug"])
}
</script>